import { queryKey } from '../constants/queryClientKey';
import {
  createDevice,
  deleteDevice,
  getDevices,
  updateDevice,
} from '../apis/devices.api';
import { sortObjectKeys } from '@vindr/utils/helpers/common.helper';
import {
  UseQueryOptions,
  UseQueryResult,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';

export function useGetDevices(
  params: Parameters<typeof getDevices>[0],
  options?: UseQueryOptions
) {
  return useQuery(
    [queryKey.devices, sortObjectKeys(params)],
    () => getDevices(params),
    {
      ...options,
    }
  ) as UseQueryResult<Awaited<ReturnType<typeof getDevices>>>;
}

export function useCreateDevice() {
  const queryClient = useQueryClient();

  return useMutation(
    async (params: Parameters<typeof createDevice>[0]) => createDevice(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.devices]);
      },
      onError: (err) => {
        console.error('useCreateDevice:', err);
      },
    }
  );
}

type ParamsUpdateDevice = Parameters<typeof updateDevice>;
export function useUpdateDevice() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({
      id,
      data,
    }: {
      id: ParamsUpdateDevice[0];
      data: ParamsUpdateDevice[1];
    }) => updateDevice(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.devices]);
      },

      onError: (err) => {
        console.error('useUpdateDevice:', err);
      },
    }
  );
}

export function useDeleteDevice() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => deleteDevice(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.devices]);
    },
    onError: (err) => {
      console.error('useDeleteDevice:', err);
    },
  });
}
